export const ProfileIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" />
            <path
                d="M13.3098 6.35486C13.3098 8.2077 11.8077 9.70972 9.9549 9.70972C8.10206 9.70972 6.60004 8.2077 6.60004 6.35486C6.60004 4.50202 8.10206 3 9.9549 3C11.8077 3 13.3098 4.50202 13.3098 6.35486Z"
                fill="currentColor"
            />
            <path
                d="M4 16C4 16 6.69024 18 10 18C13.3098 18 15.8261 16 15.8261 16C15.3641 12.9086 12.8926 10.5483 9.91307 10.5483C6.9335 10.5483 4.462 12.9086 4 16Z"
                fill="currentColor"
            />
        </svg>
    );
};
